import {z} from 'zod';
export const requestLocationSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number").regex(/^[0-9+\-\s()]+$/, "Invalid phone number format"),
  city: z.string().min(2, "City name must be at least 2 characters"),
  state: z.string().min(2, "State name must be at least 2 characters"),
  message: z.string().optional(),
})

export type RequestLocationFormData = z.infer<typeof requestLocationSchema>